import Vue from 'vue'
export default function() {
  Vue.filter('domainType', (itemType) => {
    let item = ''
    switch (itemType) {
      case 'jyeoo':
        item = '菁优网'
        break
      case 'zxxk':
        item = '学科网'
        break
      case 'zujuan':
        item = '21世纪组卷'
        break
      case 'wenku':
        item = '文库'
        break
    }
    return item
  })
}
